import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initNativeFeatures } from "./lib/native-setup";
import { registerServiceWorker } from "./lib/register-sw";

// Apply stored theme immediately to avoid flash
const storedTheme = localStorage.getItem("trades-toolbelt-theme") || "dark";
document.documentElement.classList.add(storedTheme);

// Initialize native iOS features (status bar, splash screen)
initNativeFeatures();

// Offline-first: register the cached app shell (never in dev/preview)
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
